//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets subscription options details.
 * @param level (optional) Level of requested subscription.
 */
export function getByLevel(level?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SubscriptionOptionDto> {
    let url_ = getBaseUrl() + "/api/subscription-options?";
    if (level === null)
        throw new Error("The parameter 'level' cannot be null.");
    else if (level !== undefined)
        url_ += "level=" + encodeURIComponent("" + level) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetByLevel,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetByLevel?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetByLevel(_response);
    });
}

function processGetByLevel(response: AxiosResponse): Promise<Types.SubscriptionOptionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSubscriptionOptionDto(resultData200);
        return Promise.resolve<Types.SubscriptionOptionDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SubscriptionOptionDto>(null as any);
}
let _requestConfigGetByLevel: Partial<AxiosRequestConfig> | null;
export function getGetByLevelRequestConfig() {
  return _requestConfigGetByLevel;
}
export function setGetByLevelRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetByLevel = value;
}
export function patchGetByLevelRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetByLevel = patch(_requestConfigGetByLevel ?? {});
}